import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions, mapState } from "vuex";
import PropertyOwned from "./property-owned.vue";
import VisibilityToggleMixin from "@Shared/utils/application-mixins/visibility-toggle-mixin";
import { CHANGE_OTHER_PROPERTIES, ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP } from "../../../store/application-actions";
import { OTHER_PROPERTIES_BY_APPLICANT } from "../../../store/application-getters";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import PropertyMixin from "@Broker/@Modules/clients/applications/application/select-options/property-mixin";
import MortgageDetailsMixin from "@Broker/@Modules/clients/applications/application/select-options/mortgage-details-mixin";
import { cloneDeep, get, groupBy, max, keys } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { randomString } from "@Shared/utils/utils";
export default defineComponent({
  name: "OtherProperties",
  components: {
    PropertyOwned
  },
  mixins: [DuplicatorMixin, VisibilityToggleMixin, PropertyMixin, MortgageDetailsMixin],
  props: {
    currentApplication: {
      type: Object,
      required: true
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    applicantIndex: {
      type: Number,
      default: 0
    },
    coApplicantsDisabled: {
      type: Boolean,
      default: false
    },
    isMainApplicantScreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      properties: [],
      allProperties: [],
      propId: randomString()
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [OTHER_PROPERTIES_BY_APPLICANT, "allOtherProperties"])), mapState("ApplicationStore", ["emptyApplication"])), {}, {
    pluralizedPropertyName() {
      return pluralize(this.$t("application-form.property")).toLowerCase();
    },
    otherPropertiesByApplicant() {
      return this.OTHER_PROPERTIES_BY_APPLICANT(this.applicantIndex);
    },
    applicantSelectOptions() {
      const coapps = this.currentApplication["co-applicants"];
      const areCoapps = this.currentApplication["main-applicant"]["personal-details"]["coapp"];
      const coappsOptions = areCoapps === true ? _mapInstanceProperty(coapps).call(coapps, (coapp, index) => {
        const {
          "first-name": firstName,
          "last-name": lastName
        } = coapp["personal-details"];
        const numeralTitle = `${this.$options.filters.formatNumeral(index + 1, "0o")} ${this.$t("application-form.co-applicant").toLowerCase()}`;
        return {
          label: firstName ? `${firstName} ${lastName || ""} - ${numeralTitle}` : `${numeralTitle}`,
          value: index + 1
        };
      }) : [];
      const {
        "first-name": firstName,
        "last-name": lastName
      } = this.currentApplication["main-applicant"]["personal-details"];
      return [{
        label: firstName ? `${firstName} ${lastName || ""} - ${this.$t("application-form.main-applicant")}` : this.$t("application-form.main-applicant"),
        value: 0
      }, ...coappsOptions];
    },
    propertySource() {
      const currentFlow = this.currentApplication.flow;
      return this.otherPropertiesByApplicant.length ? this.otherPropertiesByApplicant : this.emptyApplication[currentFlow]["main-applicant"]["other-properties"];
    }
  }),
  watch: {
    otherPropertiesByApplicant(properties) {
      this.properties = _mapInstanceProperty(properties).call(properties, property => cloneDeep(property));
      if (this.editVisibility && !this.properties.length) {
        this.addProperty();
      }
    },
    allOtherProperties(properties) {
      this.allProperties = _mapInstanceProperty(properties).call(properties, property => cloneDeep(property));
    }
  },
  mounted() {
    var _context, _context2;
    this.properties = _mapInstanceProperty(_context = this.otherPropertiesByApplicant).call(_context, property => cloneDeep(property));
    this.allProperties = _mapInstanceProperty(_context2 = this.allOtherProperties).call(_context2, property => cloneDeep(property));
    if (this.editVisibility && !this.properties.length) {
      this.addProperty();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [CHANGE_OTHER_PROPERTIES, ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP])), {}, {
    handleSave() {
      this.$emit("save");
    },
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    getProperty(propertyIndex) {
      return cloneDeep(this.otherPropertiesByApplicant[propertyIndex]);
    },
    handleRemoveProperty(propertyIndex) {
      this.$delete(this.properties, propertyIndex);
    },
    addProperty() {
      var _context3;
      const currentFlow = this.currentApplication.flow;
      const basePath = this.applicantIndex == 0 ? "[main-applicant]" : `[co-applicants][${this.applicantIndex - 1}]`;
      const path = `${basePath}['other-properties']`;
      const maxOrder = this.properties.length ? max(_mapInstanceProperty(_context3 = this.properties).call(_context3, ({
        order
      }) => order)) + 1 : 0;
      const what = _objectSpread(_objectSpread({}, cloneDeep(this.emptyApplication)[currentFlow]["main-applicant"]["other-properties"][0]), {}, {
        order: maxOrder
      });
      this.handleDuplicate({
        what,
        where: path,
        startEmpty: !this.properties.length,
        markAsVisible: !this.properties.length
      });
    },
    handleDuplicate({
      what,
      where,
      startEmpty,
      markAsVisible
    }) {
      this.ADD_APPLICATION_GROUP({
        what,
        where,
        startEmpty,
        markAsVisible
      });
      if (this.editVisibility) return;
      this.handleSave();
    },
    getApplicantKey(applicantIndex) {
      return applicantIndex === 0 ? "main-applicant" : `co-applicants[${applicantIndex - 1}]`;
    },
    getApplicantForProperty(property) {
      const path = this.getApplicantKey(property.applicantIndex);
      return get(this.currentApplication, path);
    },
    /**
     *  The applicant index works as intented, with the first applicant (0) being the main applicant,
     * and the applicant 1 being the first co-applicant, and so on. However, the property index is based
     * on the order of the properties owned by the applicant, and not the order of the properties in the
     * applicant as a whole.
     *
     *  The first step is to only take a view of the applicant's properties but ordered as if those are the only
     * properties, then the applicantIndex is modified to reflect the ownership change.
     *
     *  Since the filter returns a reference to the original objects, there's no need to restore the original
     * order.
     */
    handlePropertyOwnership(applicantIndex, propertyIndex) {
      const allPropertiesCopy = cloneDeep(this.allProperties);
      const applicantIndexesWithProperties = keys(groupBy(allPropertiesCopy, "applicantIndex"));
      const allPropertiesForThisApplicant = _filterInstanceProperty(allPropertiesCopy).call(allPropertiesCopy, property => property.applicantIndex === this.applicantIndex);
      allPropertiesForThisApplicant[propertyIndex].applicantIndex = applicantIndex;
      const dataByApplicant = groupBy(allPropertiesCopy, "applicantIndex");
      applicantIndexesWithProperties.forEach(index => {
        if (!dataByApplicant[index]) {
          dataByApplicant[index] = [];
        }
      });
      this.CHANGE_OTHER_PROPERTIES(dataByApplicant);
      this.handleSave();
      this.propId = randomString();
    },
    handlePageChange(page, opts) {
      this.$emit("page-change", page, opts);
    },
    handleResize(path, opts) {
      this.$emit("change-height", path, opts);
    },
    handleHeightRemove(path, opts) {
      this.$emit("height-remove", path, opts);
    },
    tabIndex(value) {
      return this.applicantIndex === 1 ? value + 1 : value;
    }
  })
});